// import Swiper from "swiper";
import { cpSearch } from "./modules/cp-search";
import { experts } from "./modules/experts";
import { heroes } from "./modules/heroes";
import { jobApplications } from "./modules/job-applications";
import { jobSearch } from "./modules/job-search";
import { mainNavHamburger } from "./modules/main-nav-hamburger";
import { misc } from "./modules/misc";
import { navDropdown } from "./modules/nav-dropdown";
import { publications } from "./modules/publications";
import { scrollToTop } from "./modules/scroll-to-top";
import { stickyNav } from "./modules/sticky-nav";

/**
 * Document load
 */
document.addEventListener("DOMContentLoaded", function () {
  experts();
  mainNavHamburger();
  navDropdown();
  jobSearch();
  publications();
  jobApplications();
  cpSearch();
  stickyNav();
  scrollToTop();
  heroes();
  misc();
});
